(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('consignmentPlan', {
        templateUrl: 'views/components/views/consignmentPlan/consignmentPlan.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', 'stateService', 'utilityService', 'translateService', 'modalService', 'consignmentPlanService', 'transportAreasService', 'economyService', 'typeaheadService', function ($stateParams, stateService, utilityService, translateService, modalService, consignmentPlanService, transportAreasService, economyService, typeaheadService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let custactNo = $stateParams.custact_no;

            let translations = {
                error: '',
                ok: ''
            };

            vm.model = {
                custactNo: $stateParams.custact_no,
                equipmentNameButtonsUnselected: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') }
                ],
                equipmentNameButtonsSelected: [
                    { id: 'list', icon: 'fa fa-solid fa-bars', color: 'primary', type: 'primary', onClick: () => stateService.go('equipments') },
                    { id: 'goto', icon: 'fa fa-solid fa-chevron-right', color: 'primary', type: 'primary', onClick: () => stateService.go('equipmentedit', { equipment_id: vm.model.edit.equipment_id }) }
                ],
                mconfig: {
                    enabled: true,		// Is the menu enabled
                    show: true,			// Is the menu visible or not
                    activate: function (item) {
                        if (angular.isDefined(item)) {
                            vm.model.mconfig.records[item.item_id].isActive = true;
                        } else if (item === 'all') {
                            angular.forEach(vm.model.mconfig.records, function (data) {
                                if (angular.isDefined(data)) {
                                    if (data.canActive === true) {
                                        data.isActive = true;
                                    }
                                }
                            });
                        } else {
                            vm.model.mconfig.records[0].isActive = true;
                        }
                    },
                    deactivate: function (item) {
                        if (angular.isDefined(item)) {
                            vm.model.mconfig.records[item.item_id].isActive = false;
                        } else if (item === 'all') {
                            angular.forEach(vm.model.mconfig.records, function (data) {
                                if (angular.isDefined(data)) {
                                    if (data.canActive === true) {
                                        data.isActive = false;
                                    }
                                }
                            });
                        } else {
                            vm.model.mconfig.records[0].isActive = false;
                        }
                    },
                    function: function (item) {
                        if (item.canActive === true) {
                            item.isActive = !item.isActive;
                        }
                    },
                    records: [
                        { item_id: '0', item_name: 'sort', glyph: 'glyphicon-sort', color: 'primary', canActive: true, isActive: false, colorActive: 'warning', isIcon: false, enabled: true, show: true },
                        { item_id: '99', item_name: 'save', glyph: 'glyphicon-save', color: 'primary', animate: null, isIcon: true, enabled: false, show: true }
                    ]
                },
                edit: {},
                selectListActStatuses: [],
                selectListStockPlaces: [],
                selectListTransportAreas: [],
                itemsListOnPlans: [],
                lockedSave: false
            };

            // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATE SERVICE

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATE SERVICE

            async function loadEdit() {
                vm.model.edit = (await consignmentPlanService.getEdit({ custact_no: custactNo }))[0];

                Promise.all([
                    loadActStatuses(),
                    loadTransportAreas(),
                    loadOnPlans()
                ]).then(() => Promise.resolve());
            }

            async function loadStockplaces() {
                vm.model.selectListStockPlaces = (await consignmentPlanService.listStockPlaces());
            }

            async function loadActStatuses() {
                if (utilityService.validateParmsValue(vm.model.edit.activitytype_no) !== true) return;

                vm.model.selectListActStatuses = (await economyService.listActivityStatuses({ activitytype_no: vm.model.edit.activitytype_no }));
            }

            async function loadTransportAreas() {
                if (utilityService.validateParmsValue(vm.model.edit.stockplace_id) !== true) return;

                vm.model.selectListTransportAreas = (await transportAreasService.listAreas({
                    add_all: '0',
                    stockplace_id: vm.model.edit.stockplace_id
                }));
            }

            async function loadOnPlans() {
                if (utilityService.validateParmsValue(vm.model.edit.custact_no) !== true) return;

                vm.model.itemsListOnPlans = (await consignmentPlanService.listOnPlans({ custact_no_consignmentplan: vm.model.edit.custact_no }));
            }

            // ## DRAG AND DROP SORT FUNCTION PROCEDURE CALLS ##

            vm.consignmentPlansReorder = function (item) {
                for (var m = 0; m < vm.model.mconfig.records.length; m++) {
                    if (angular.isDefined(vm.model.mconfig.records[m]) && vm.model.mconfig.records[m].item_id === '99') {
                        vm.model.mconfig.records[m].animate = true;
                        break;
                    }
                }

                var updateParms = {
                    custact_no: vm.model.custactNo,
                    records: vm.model.itemsListOnPlans.map(function (a) { return { "consignment_keyno": a.consignment_keyno }; })
                };

                consignmentPlanService.updateOrder(updateParms).then(function (data) {
                    if (data[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: 'Varsel',
                            message: data[0].errormessage,
                            buttons: [{
                                label: 'OK',
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    loadOnPlans();
                                }
                            }]
                        });
                    } else {
                        console.dir(data);
                        loadOnPlans();

                        for (var m = 0; m < vm.model.mconfig.records.length; m++) {
                            if (angular.isDefined(vm.model.mconfig.records[m]) && vm.model.mconfig.records[m].item_id === '99') {
                                vm.model.mconfig.records[m].animate = false;
                                break;
                            }
                        }

                        $timeout(function () {
                            vm.model.mconfig.records[m].animate = null;
                        }, 2000);
                    }
                });
            };

            // #region TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            vm.typeaheadSearch = function (value, id) {
                switch (id) {
                    case 'equipment_name':
                        vm.model.edit[id] = value;

                        return typeaheadService.lookUpEquipments({ equipment_name: vm.model.edit[id] || '' });
                        break;
                    default:
                        break;
                }
            };

            // #endregion TYPEAHEAD SEARCH SINGLE PROCEDURE FUNCTION CALL

            // #region SELECTED VALUE FUNCTION

            vm.onTypeaheadSelected = function (item, id) {
                switch (id) {
                    case 'equipment_name':
                        if (item) {
                            vm.model.edit.equipment_id = item?.item_id ?? '';
                            vm.model.edit.equipment_name = item?.item_name ?? '';
                        } else {
                            vm.onTypeaheadClear('equipment_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion SELECTED VALUE FUNCTION

            // #region CHANGED VALUE FUNCTION

            vm.onTypeaheadChanged = function (value, item, id) {
                switch (id) {
                    case 'equipment_name':
                        vm.model.edit.equipment_name = value;

                        if (value) {
                            if (item?.item_id) {
                                vm.model.edit.equipment_id = item.item_id;
                            }
                        } else {
                            vm.onTypeaheadClear('equipment_name');
                        }
                        break;
                    default:
                        break;
                }
            };

            // #endregion CHANGED VALUE FUNCTION

            // #region CLEAR VALUE FUNCTION

            vm.onTypeaheadClear = function (id) {
                switch (id) {
                    case 'equipment_name':
                        vm.model.edit.equipment_id = '';
                        vm.model.edit.equipment_name = '';
                        break;
                    default:
                        break;
                }
            };

            // #endregion CLEAR VALUE FUNCTION

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                consignmentPlanService.saveObj(vm.model.edit).then((response) => {
                    if (response[0] && response[0].errorcode !== '0') {
                    	modalService.show({
                    		type: 'warning',
                    		title: translations.error,
                    		message: response[0].errormessage,
                    		buttons: [{
                    			label: translations.ok,
                    			cssClass: 'btn-warning',
                    			action: function (dialogItself) {
                    				dialogItself.close();
                    				vm.model.lockedSave = false;
                    			}
                    		}]
                    	});
                    } else {
                    	vm.model.lockedSave = false;
                    	stateService.back();
                    }
                });
            };

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'activitytype':
                        go({ activitytype_no: vm.model.edit.activitytype_no });
                        break;
                    default:
                        break;
                }
            };

            // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            vm.onStockPlaceChanged = function (value) {
                vm.model.edit.stockplace_id = value;
                loadTransportAreas();
            }

            vm.$onInit = async function () {
                translate();
                await Promise.all([loadStockplaces()]);
                loadEdit();
            }
        }]
    });
})();
